import React from 'react';

import { Box, Stack } from '@mui/material';

type Props = {
  description: JsxNode;
  videoSource: string;
  videoTitle: string;
};

export function EmptyTutorial({ description, videoSource, videoTitle }: Props) {
  // We add `t=0.001` to force iOS to show the first frame of the video
  const src = `${videoSource}#t=0.001`;

  return (
    <Box py={5} px={3}>
      <Stack
        spacing={3}
        sx={{
          p: 4,
          px: 3,
          maxWidth: 725,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          mx: 'auto',
          textWrap: 'balance',
        }}
        alignItems="center"
        justifyContent="center"
      >
        <Box sx={{ maxWidth: 480 }}>{description}</Box>
        <Box
          component="video"
          controls
          preload="metadata"
          title={videoTitle}
          sx={{
            display: 'block',
            margin: '0px auto 4px 0px',
            maxWidth: '100%',
            width: '100%',
            aspectRatio: '16 / 9',
          }}
        >
          <source src={src} type="video/mp4" />
        </Box>
      </Stack>
    </Box>
  );
}
